var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"page-section dev-page_nice-switch"},[_c('h1',[_vm._v("NiceWizard2")]),_c('nice-wizard-2',[_c('section',[_vm._v(" step 1 ")]),_c('section',[_vm._v(" step 2 ")]),_c('section',[_vm._v(" step 3 ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }